/**
 * CommonJS path helpers for Netlify prerender / Node sitemap (mirrors paths.ts).
 */
const LOCALES = {
  "en-US": { pathPrefix: null, audiencePathStyle: "for" },
  "es-ES": { pathPrefix: "es-es", audiencePathStyle: "para" },
  "es-MX": { pathPrefix: "es-mx", audiencePathStyle: "para" },
  "en-CA": { pathPrefix: "en-ca", audiencePathStyle: "for" },
  "en-GB": { pathPrefix: "en-gb", audiencePathStyle: "for" },
};

const EN_AUDIENCE = {
  cities: "cities",
  "local-governments": "local-governments",
  hoas: "hoas",
};

const ES_AUDIENCE = {
  cities: "ayuntamientos",
  "local-governments": "gobiernos-locales",
  hoas: "comunidades",
};

function localizedPath(path, locale) {
  const config = LOCALES[locale] || LOCALES["en-US"];
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (!config.pathPrefix) return normalized;
  if (normalized === "/") return `/${config.pathPrefix}`;
  return `/${config.pathPrefix}${normalized}`;
}

function audienceRelativePath(audience, locale) {
  const config = LOCALES[locale] || LOCALES["en-US"];
  const segment =
    config.audiencePathStyle === "para"
      ? ES_AUDIENCE[audience]
      : EN_AUDIENCE[audience];
  return config.audiencePathStyle === "para"
    ? `/para/${segment}`
    : `/for/${segment}`;
}

function audiencePath(audience, locale) {
  return localizedPath(audienceRelativePath(audience, locale), locale);
}

function pricingRelativePath(locale) {
  const config = LOCALES[locale] || LOCALES["en-US"];
  return config.audiencePathStyle === "para" ? "/precios" : "/pricing";
}

function pricingPath(locale) {
  return localizedPath(pricingRelativePath(locale), locale);
}

const PREFIXED = Object.keys(LOCALES).filter((k) => LOCALES[k].pathPrefix);

module.exports = {
  LOCALES,
  PREFIXED,
  localizedPath,
  audiencePath,
  pricingPath,
  audienceRelativePath,
  pricingRelativePath,
};
